// route/COM001L1.js

import React, {createContext, useContext, useEffect, useState} from "react";
import {Navigate} from 'react-router-dom';

import {AuthContext} from "contexts/AuthContext"

import style from './COM001L1.module.scss';

import COM001F1 from "pages/COM/COM001F1";
import COM002F1 from "pages/COM/COM002F1";
import COM201F1 from "pages/COM/COM201F1";
import Icon from "components/Icon/Icon";

import * as MS from 'pages/MS'
import * as MI from 'pages/MI'
import * as MC from 'pages/MC'
import * as RE from 'pages/RE'
import styled from "styled-components";


const pageList = [

  { comp: <MS.MSC101F1/>, menuId: '010002', menuCd: 'MSC101F1' }, // 공통코드 관리
  { comp: <MS.MSU101F1/>, menuId: '010201', menuCd: 'MSU101F1' }, // 사용자관리
  { comp: <MS.MSR101F1/>, menuId: '010101', menuCd: 'MSR101F1' }, // 롤관리
  { comp: <MS.MSM101F1/>, menuId: '010102', menuCd: 'MSM101F1' }, // 메뉴관리
  { comp: <MS.MSA101F1/>, menuId: '010006', menuCd: 'MSA101F1' }, // 대시보드 관리
  { comp: <MS.MSL101F1/>, menuId: '010004', menuCd: 'MSL101F1' }, // 로그관리

  { comp: <MI.MIN101F1/>, menuId: '020001', menuCd: 'MIN101F1' }, // 공지사항
  { comp: <MI.MIQ101F1/>, menuId: '020002', menuCd: 'MIQ101F1' }, // Q&A

  { comp: <RE.REG100F1/>, menuId: '030001', menuCd: 'REG100F1' }, // New case
  { comp: <RE.REG200F1/>, menuId: '030002', menuCd: 'REG200F1' }, // Subject list
  { comp: <RE.REG210F1/>, menuId: '030004', menuCd: 'REG200F1' }, // Query list
  { comp: <RE.REG300F1/>, menuId: '030003', menuCd: 'REG300F1' }, // edit
];

const StyDiv_tab__button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 185px;
  height: 40px;

  font : 500 16px/1.5 Pretendard;
  color: ${props => props.$sel ? '#FFFFFF' : '#9E9E9E'};
  
  cursor: pointer;
  padding: 3px 16px;

  transition: background-color 0.3s ease, border-color 0.3s ease; /* 애니메이션 천천히 */
      
  border:none;
  border-radius: 200px;
  
  background-color: ${props => props.$sel ? '#2B3944' : '#E0E0E0'};
  
  .close__button{
    width: 16px;
    height: 16px;
    margin-left: auto;        
  }
`
const StyDiv_nav = styled.div`
  
  width: 100%;
  //min-height: 88px;
  
  //margin: 26px 0 24px 0;
  
  padding: 24px 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  row-gap: 16px;
  
  font : normal 700 24px/1.5 Pretendard;
  color: #032030;
  
  border-bottom: #d5d5d5 solid 1px; 
  
  .nav__title{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &:before {
      content: "";
      margin-right: 8px;
      width: 24px;
      height: 24px;
      
      background-image: url(
          ${props => {
              const imageId = props.$menuId.substring(0, 2);
              return imageId ? require(`../../assets/images/ico_menuTitle_O_` + imageId + `.svg`) : "";
          }}
      );

      background-size: 24px 24px;
      background-repeat: no-repeat;
      background-position: center;

      transition: background-image 0.5s ease;
    }
  }
`


const NavBar = ({ selMenu, children}) => {

  return (
    <StyDiv_nav $menuId={selMenu.menuId}>{/* 네이게이터 */}
      <div className="nav__title">
        {selMenu.menuPos.split(">").map((part, index, array) => (
          <React.Fragment key={index}>
            {part}
            {index < array.length - 1 && <Icon id="rightAngleBrackets_03" width="24" height="24" />}
          </React.Fragment>
        ))}
      </div>
      {children}
    </StyDiv_nav>
  );
};


export const MenuContext = createContext();

const COM001L1 = () => {

  const authContext = useContext(AuthContext);

  const [tabs, setTabs] = useState([]);
  const [selTab, setSelTab] = useState(0);
  const [nextTabId, setNextTabId] = useState(1);

  const [isShowDash, setIsShowDash] = useState(true);

  useEffect(() => {
      setIsShowDash(tabs.length <= 0 || selTab === null);
  }, [tabs, selTab]);

  // 페이지 수동
  const addPage_manual = (selMenu, param= {}, reStatYn='N') => {
    setPage(selMenu.menuId, selMenu, param, reStatYn);
  }

  // 페이지 추가
  const addPage = (menuId, param= {}, reStatYn='N') => {
    const menuList = JSON.parse(sessionStorage.getItem("menuList"));
    const selMenu = menuList.find(menu => menu.menuId === menuId);
    setPage(menuId, selMenu, param, reStatYn);
  }

  const setPage = (menuId, selMenu, param, reStatYn) => {
    const actComp = pageList.find(page => page.menuId === menuId)?.comp;
    const navBarComp = (props) => (
      <NavBar selMenu={selMenu} {...props} />
    );

    const existingTabIndex = tabs.findIndex(tab => tab.menuId === menuId);

    // 기존 탭이 있고, reStatYn이 'N'이면 해당 탭 선택만
    if (existingTabIndex !== -1 && reStatYn === 'N') {
      setSelTab(existingTabIndex);
      return;
    }

    // 기존 탭이 있고, reStatYn이 'Y'이면 해당 탭을 재설정 (초기화)
    if (existingTabIndex !== -1 && reStatYn === 'Y') {

      const newTabs = [...tabs];
      newTabs[existingTabIndex] = {
        ...newTabs[existingTabIndex],
        key: `tab-${menuId}-${Date.now()}`, // 새로운 key를 부여하면 React가 해당 컴포넌트를 새로 마운트함
        title: selMenu.menuTl,
        page: actComp,
        navBar: navBarComp,
        props: param
      };
      setTabs(newTabs);
      setSelTab(existingTabIndex);
      authContext.onTimeReset();
      return;
    }

    // 새로운 탭 추가
    const newTab = {
      id: nextTabId,
      title: selMenu.menuTl,
      page: actComp,
      menuId: menuId,
      menuPos: selMenu.menuPos,
      navBar: navBarComp,
      key: `tab-${menuId}-${Date.now()}`,
      props: param
    };

    authContext.onTimeReset();

    setTabs([...tabs, newTab]);
    setNextTabId(nextTabId + 1);
    setSelTab(tabs.length);
  };

  const rmTab = (e, idx) => {
    e.stopPropagation(); //버튼간 간섭 하지 않게 하기

    const newTabs = tabs.filter((_, i) => i !== idx);
    setTabs(newTabs);

    let setIdx = 0;

    if (newTabs.length === 0) { // 탭이 비여 있을 경우
        setIdx = 0;
    } else if (selTab === idx && idx === tabs.length - 1) { //닫는 탭이 마지막에 있고 선택된 탭일경우
        setIdx = idx - 1;
    } else if (selTab >= idx) { // 닫는 탭이 선택된 탭보다 앞에 있거나 같을때
        setIdx = selTab - 1;
    } else if (selTab < idx) { // 닫는 탭이 선택된 탭보다 뒤에 있을때
        return;
    }

    if(setIdx === -1){
      setIdx = tabs.length - 2;  // 마지막 탭으로 셋팅(0부터 시작하기 때문 -2를함.)
    }

    setSelTab(setIdx);
  };

  const showDash = () => {
      setIsShowDash(true);
      setSelTab(null);
  };

  return (
    authContext.isLoggedIn ?
      (
        <MenuContext.Provider value={{ addPage, addPage_manual }}>
          <div className={style.root_wrap}>
            <div className={style.header_wrap}><COM001F1/>{/* 해더 페이지 */}</div>
            <div className={style.content_wrap}>
              <div className={style.leftNav_wrap}><COM002F1 tabLength={tabs.length}/>{/* 좌측 메뉴 */}</div>
              <div className={style.article_wrap}>
                <div className={style.tab_wrap}>{/* 탭 페이지 */}
                  <div className={style.mainDash__button} onClick={() => showDash(true)}>{/* 홈데쉬 보드 바로가기 버튼 */}</div>
                  <div className={style.tabBg}>
                  {tabs.map((tab, index) => (
                    <StyDiv_tab__button key={index} onClick={() => setSelTab(index)} $sel={selTab === index}>
                      {tab.title}
                      <button className="close__button" onClick={(e) => rmTab(e, index)}>
                        <Icon id={selTab === index?"close_02":"close_03"} width="16" height="16"/>
                      </button>
                    </StyDiv_tab__button>
                  ))}
                  </div>
                  <div className={style.tabClose_button} onClick={(e) => setTabs([])}>{/* 탭 전체 닫기 버튼 */}</div>
                </div>

                  <div className={style.center_wrap}> {/* 메인 페이지 */}
                    {tabs.map((tab, index) => (
                      <div key={tab.id || tab.title}  className={style.work_wrap} style={{display: selTab === index ? 'flex' : 'none', flex: 1, flexDirection: 'column',}}>
                        <div className={style.cont_wrap}>
                          {React.cloneElement(tab.page, {
                            key: tab.key || tab.id,
                            isActive: selTab === index,
                            navBar : tab.navBar,
                            ...(tab.props || {}),
                          })}
                        </div>
                      </div>
                      )
                    )}
                    <div className={style.work_wrap} style={{display: isShowDash ? 'block' : 'none'}}> {/*대시보드*/}
                      <COM201F1/>
                    </div>
                  </div>
                  <div className={style.bottom_wrap}>
                    {/*테스트 중 (해당 문구 삭제 예정)*/}
                  </div>
              </div>
            </div>
          </div>
        </MenuContext.Provider>
      )
      :
      <Navigate to="/"/>
  );
};

export default COM001L1;
